<template>
  <v-row justify="center" align="center" style="height:100%">
    <v-col>
      <img
        v-if="index===null"
        src="movs/vidPoster.png"
        style="max-width:100%; width:470px; cursor:pointer;margin-bottom:20px;"
        @click="index=0"
        />
      <video width="470" height="265" controls :key="'vid'+index" style="margin-bottom:20px;max-width:100%" v-if="index!==null" autoplay>
        <source :src="movs[index].src" type="video/mp4">
          Your browser does not support the video tag.
      </video>
      <NavDots :items="movs" :index="index" :click="function(i){index=i}" arrows />
      <v-btn v-if="index!==null" download text :href="movs[index].dl" color="isYellow">Download Text</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import NavDots from '../components/NavDots'

export default {
  components: {
    NavDots
  },
  name: 'Movies',
  props: [
    'movs'
  ],
  data () {
    return {
      index: null // default: 0
    }
  }
}
</script>
